import { Outlet } from 'react-router-dom'
import AdminNav from './AdminNav'

export default function AdminLayout() {
  return (
    <div className="flex h-[calc(100vh-4rem)] -mx-4 sm:-mx-6 lg:-mx-8 -my-6">
      {/* Sidebar Navigation */}
      <aside className="w-64 shrink-0 bg-white border-r border-gray-200 overflow-y-auto">
        <div className="p-4 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900 whitespace-nowrap">Admin Panel</h1>
        </div>
        <AdminNav />
      </aside>

      {/* Main Content */}
      <main className="flex-1 min-w-0 overflow-auto p-8 bg-gray-50">
        <Outlet />
      </main>
    </div>
  )
}
